"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _i18n = require("../../../../i18n");
var _constants = require("../../constants");
var _helpers = require("./helpers");
const useErrorValidation = value => {
  const {
    T
  } = (0, _i18n.useTranslation)();
  const rules = {
    required: {
      message: T.translate('form.errors.name')
    },
    maxLength: {
      message: T.translate('form.errors.maxLength', {
        maxLength: _constants.NAME_MAX_LENGTH
      })
    }
  };
  const [errors, setErrors] = (0, _react.useState)({});
  const [errorMessage, setErrorMessage] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    const errors = (0, _helpers.validateRules)(_constants.NAME, value, rules);
    const errMsg = (0, _helpers.generateErrorMsg)(_constants.NAME, errors, rules);
    setErrors(errors);
    setErrorMessage(errMsg);
  }, [value]);
  return {
    errorMessage,
    errors
  };
};
var _default = exports.default = useErrorValidation;